module.exports = __webpack_public_path__ + "fr.c9e464d9efd3ba80716a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/fr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/fr.svg
// module chunks = styles